import { Injectable } from "@angular/core";
import { WebApiClient } from "../web-api-client.service";
import { WebApiService } from "../web-api.service";

export interface ValidateLicenseRequest {
    Code: string;
    LicenseKey: string;
    DeviceFingerprint: string;
}

export interface ReleaseDeviceRequest {
    Code: string;
    LicenseKey: string;
}

export interface LicenseActionResponse {
    Success: boolean;
    LicenseKey?: string;
    Message: string;
}

@Injectable({ providedIn: "root" })
export class LicenseApi {
    apiService: WebApiService;

    constructor(private apiClient: WebApiClient) {
        this.apiService = this.apiClient.createHisService("api/license");
    }

    async Validate(request: ValidateLicenseRequest): Promise<LicenseActionResponse> {
        return await this.apiService.post("validate", request).toPromise<LicenseActionResponse>();
    }

    async Release(request: ReleaseDeviceRequest): Promise<LicenseActionResponse> {
        return await this.apiService.post("release", request).toPromise<LicenseActionResponse>();
    }
}
